var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-xl-flex"
  }, [_c('a', {
    staticClass: "gnb__link",
    attrs: {
      "href": "https://secure.donus.org/withcan/mypage",
      "target": "_blank"
    }
  }, [_vm._v("마이페이지")]), _c('a', {
    staticClass: "gnb__link donation-link",
    attrs: {
      "href": "https://secure.donus.org/withcan/pay",
      "target": "_blank"
    }
  }, [_vm._v("후원하기")])]);

}]

export { render, staticRenderFns }